<!-- gap rather than space-x, whose `> * + *` margin outranks the Smart Link button's ml-auto. -->
<div
  class="flex items-center justify-between gap-4 px-6 py-4 border rounded"
  [ngClass]="statusConfigs.cssClasses()"
>
  <div class="flex flex-col space-y-1">
    <h3
      class="text-base font-bold text-project-2000"
      data-testid="status-card-title"
    >
      Status: {{ statusConfigs.title() }}
    </h3>
    <div class="flex space-x-1 text-sm italic text-inherit brightness-75">
      <span
        *ngIf="content.isPublished() && content.publishedDate"
        data-testid="published-date"
        >Publish Date:
        {{ content.publishedDate | date : "dd/MM/yyyy - HH:mm" }}</span
      >
      <span *ngIf="content.lastUpdatedDate" data-testid="last-updated-on-date"
        >Last Modified:
        {{ content.lastUpdatedDate | date : "dd/MM/yyyy - HH:mm" }}</span
      >
      <span
        *ngIf="!content.lastUpdatedDate && content.createdDate"
        data-testid="created-date"
        >Created: {{ content.createdDate | date : "dd/MM/yyyy - HH:mm" }}</span
      >
      <p *ngIf="content.lastUpdatedByUser">
        by {{ content.lastUpdatedByUser }}
      </p>
    </div>
  </div>
  <app-active-users
    *ngIf="content.contentId"
    [contentId]="content.contentId"
    [form]="form"
    [formReady]="formReady"
    class="flex flex-1"
  >
  </app-active-users>
  <!-- Tailwind is configured `important: true`, so text-sm's line-height beats the 34px a legacy
       stroked button gets its whole height from — hence the explicit h-9 to match Save. min-w
       stops Save shifting sideways when the label becomes "Scanning…" mid-run. Colours are
       stated, not inherited, because the bar's background is one of six status tints.
       isSmartLinkDisabled folds a live run in with five refusals, so busy is styled off
       isSmartLinkRunning: :disabled would show "not now" grey for a scan that is alive. -->
  <button
    *ngIf="isSmartLinkingEnabled"
    mat-stroked-button
    type="button"
    class="inline-flex items-center justify-center h-9 px-3 ml-auto text-sm font-medium min-w-[7.5rem] shrink-0 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-project-300"
    [ngClass]="
      isSmartLinkRunning
        ? 'smart-link-busy text-project-4400 border-project-4500 bg-project-4600'
        : 'bg-white text-project-2000 border-project-2000/40 hover:text-project-300 hover:border-project-300 hover:bg-project-4600 disabled:bg-white/50 disabled:text-project-1100 disabled:border-project-2000/20'
    "
    data-testid="statusBarSmartLinkBtn"
    [disabled]="isSmartLinkDisabled"
    [title]="smartLinkTitle"
    [attr.aria-label]="smartLinkTitle"
    (click)="onRunSmartLinks()"
  >
    <span
      *ngIf="isSmartLinkRunning; else statusBarSmartLinkLabel"
      class="flex items-center gap-x-1.5"
    >
      <mat-spinner class="shrink-0" [diameter]="14"></mat-spinner>
      <span>Scanning…</span>
    </span>
    <ng-template #statusBarSmartLinkLabel>
      <span class="flex items-center gap-x-1.5">
        <app-ai-icon class="text-inherit shrink-0"></app-ai-icon>
        <span>Smart Link</span>
      </span>
    </ng-template>
  </button>
  <button
    class="basis-1/6"
    mat-button
    color="primary"
    type="submit"
    (click)="handleSave.emit($event)"
    [disabled]="form.invalid || !form.dirty || isSaving || isLoading"
    mat-raised-button
    data-testid="formSubmitBtn"
  >
    <span *ngIf="!isSaving; else saving"> Save </span>
    <ng-template #saving>
      <span>Saving...</span>
    </ng-template>
  </button>
</div>
